<template>
    <div class="com-apply-domain">
        <step-header activeKey="0"></step-header>
        <div class="com-apply-domain__main">
            <div class="com-card-title">域名解析</div>
            <div class="com-apply-domain__form com-form">
                <div :class="['com-form-item', {'is-error': isError}]">
                    <label class="com-form__item-label">网站域名 </label>
                    <input class="com-form__item-input" type="text" placeholder="如：www.xxx.com" v-model="website_url" @input="enter" />
                    <span class="com-form__item-explain" v-if="isError">请输入域名</span>
                </div>
                <div class="com-form-item com-form-item--nolabel">
                    <button class="com-btn com-btn-submit" @click="next"><i class="icon icon-loading" v-if="loading"/>下一步</button>
                </div>
            </div>
            <div class="com-divider"></div>
            <div class="com-apply-domain__tip com-alert">
                <div class="com-alert-title">域名解析说明 </div>
                <div class="com-alert-content">
                    <p>1. &nbsp;新增一条 <code>www</code> 解析记录，  类型选择 <code>CNAME</code> 解析到 <code>c-hw.youjiyouni.com</code></p>
                    <p>2. &nbsp;新增一条 <code>board</code> 解析记录， 类型选择 <code>CNAME</code> 解析到 <code>m.youjiyouni.com</code></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import StepHeader from './step-header'
export default {
    name: 'apply-domain',
    components: {
        StepHeader,
    },
    data() {
        return {
            website_url: '',
            isError: false,
            loading: false,
        }
    },
    created() {
        const params = JSON.parse(sessionStorage.getItem('params') || '{}');
        this.website_url = params.website_url;
    },
    methods: {
        enter() {
            if(this.website_url) {
                this.isError = false;
            }
        },
        next() {
            if(!this.website_url) {
                this.isError = true;
            } else {
                this.loading = true;
                this.$axios.post('/merchant/validate-website', {website_url: this.website_url}).then(res => {
                    this.loading = false;
                    if (res.data.meta.code === 0) {
                        const params = JSON.parse(sessionStorage.getItem('params') || '{}');
                        params.website_url = this.website_url;
                        sessionStorage.setItem('params', JSON.stringify(params))
                        this.$router.push({path: `/merchant/apply`, query: {s: 1}});
                        this.$emit('end')
                    } else {
                        alert(res.data.meta.error)
                    }
                })
            }
        }
    }
}
</script>

<style lang="less" scoped>
    .com-apply-domain {
        &__form {
            margin-top: 30px;
        }
        .com-divider {
            margin: 40px 0 24px;
        }
        .com-btn-submit {
            width: 100px;
            border-radius: 20px;
            margin-top: 20px;
        }
    }
</style>

